import React, { Component } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  AttachedTable,
  SummonUpgradeFeature, 
  UpgradableNumber
} from "@dndModels";
import { 
  CREATURE_TYPES 
} from "@dndModels/Constants";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import CheckBox from "@components/input/CheckBox";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";

type Props = {
  obj: SummonUpgradeFeature;
  onChange: (changed: SummonUpgradeFeature) => void; 
  disabled: boolean;
  attached_table?: AttachedTable;
}

export interface State { 
}

class SummonUpgradeFeatureInput extends Component<Props, State> {
  public static defaultProps = {
    disabled: false
  };
  // constructor(props: Props) {
  //   super(props);
  //   this.state = {
  //   };
  // }

  // componentDidMount() {
  // }

  render() {
    return (
      <Grid container spacing={0} direction="column">
        <Grid>
          <SelectStringBox 
            name="Creature Types" 
            options={CREATURE_TYPES}
            values={this.props.obj.creature_types} 
            multiple
            disabled={this.props.disabled}
            onChange={(values: string[]) => {
              const obj = this.props.obj;
              obj.creature_types = values;
              this.props.onChange(obj);
            }} 
          />
        </Grid>
        <Grid>
          <UpgradableNumberBox 
            name="Bonus HP" 
            value={this.props.obj.bonus_hp} 
            disabled={this.props.disabled}
            attached_table={this.props.attached_table}
            onChange={(value: UpgradableNumber) => {
              const obj = this.props.obj;
              obj.bonus_hp = value.clone();
              this.props.onChange(obj);
            }} 
          />
        </Grid>
        <Grid>
          <CheckBox 
            name="Per Hit Die" 
            value={this.props.obj.per_hit_die} 
            disabled={this.props.disabled}
            onChange={(value: boolean) => {
              const obj = this.props.obj;
              obj.per_hit_die = value;
              this.props.onChange(obj);
            }} 
          />
        </Grid>
      </Grid>
    );
  }
}

export default SummonUpgradeFeatureInput;
